import { Image } from "./Image";
import { StatCard } from "./StatCard";

export const AboutUsSection = () => {
  const stats = [
    { value: "$100K+", label: "Total Savings Available" },
    { value: "10K+", label: "Active Coupons" },
    { value: "500+", label: "Partner Businesses" },
    { value: "50+", label: "Sub-Categories" },
  ];

  return (
    <div>
      <div className="hidden lg:block  -mt-[120px]">
         <section className="w-full flex justify-center mt-[120px]">

      <div className="w-full max-w-[1820px] px-[80px]">

        {/* LABEL */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-[10px] h-[10px] rounded-full bg-red-600" />

          <span className="text-[17px] font-medium text-neutral-700">
            Experience More
          </span>
        </div>


        


        {/* MAIN ROW */}
        <div className="mt-[60px] flex gap-[60px] items-end">

          <div className="flex flex-col gap-10 w-[320px] shrink-0">
            {stats.map((stat, i) => (
              <StatCard key={i} value={stat.value} label={stat.label} />
            ))}
          </div>

          <div className="flex-1 min-w-0">
            {/* HEADLINE */}
        <h2 className="
          max-w-[1280px]
          text-[36px]
          leading-[1.15]
          tracking-[-1px]
          font-medium
          text-end
          mb-10
        ">
          <span className="text-neutral-500 font-normal">
            More Savings. More Rewards.{" "}
          </span>

          <span className="text-neutral-900 font-normal">
            {" "}More Local Experiences.
          </span>
        </h2>
            <Image />
          </div>

        </div>

      </div>
    </section>
      </div>
      
      <div className="block lg:hidden px-[80px]">
         <section className="w-full flex justify-center">

      <div className="w-full max-w-[1820px] ">

        {/* LABEL */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-[10px] h-[10px] rounded-full bg-red-600" />

          <span className="text-[17px] font-medium text-neutral-700">
            Experience More
          </span>
        </div>


        {/* HEADLINE */}
        <h2 className="
          max-w-[1280px]
          text-[16px]
          text-center
          leading-[1.5]
          tracking-[-1px]
          font-medium
        ">
          <span className=" font-normal">
            More Savings. More Rewards. deals and real rewards, making everyday spending smarter, simpler, and more rewarding.
          </span>
        </h2>


        {/* MAIN ROW */}
        <div className="mt-[60px] grid items-center justify-center">

          <div className="grid grid-cols-2 gap-4 w-[380px]">
            {stats.map((stat, i) => (
              <StatCard key={i} value={stat.value} label={stat.label} />
            ))}
          </div>

          

        </div>

      </div>
    </section>
      </div>
    </div>
   
  );
};